// extracted by mini-css-extract-plugin
export default {"ordersfeed":"OrdersFeed_ordersfeed__2u6kB","ordersfeedcontent":"OrdersFeed_ordersfeedcontent__LUgSo"};